function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_442",
  "data-name": "Group 442",
  transform: "translate(-903 -1675)"
}, React.createElement("circle", {
  id: "Ellipse_32",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(903 1675)"
}), React.createElement("circle", {
  id: "Ellipse_32-2",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(941 1675)"
}), React.createElement("circle", {
  id: "Ellipse_32-3",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(979 1675)"
}), React.createElement("circle", {
  id: "Ellipse_32-4",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1017 1675)"
}), React.createElement("circle", {
  id: "Ellipse_32-5",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1055 1675)"
}), React.createElement("circle", {
  id: "Ellipse_32-6",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1093 1675)"
}), React.createElement("circle", {
  id: "Ellipse_32-7",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(903 1713)"
}), React.createElement("circle", {
  id: "Ellipse_32-8",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(941 1713)"
}), React.createElement("circle", {
  id: "Ellipse_32-9",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(979 1713)"
}), React.createElement("circle", {
  id: "Ellipse_32-10",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1017 1713)"
}), React.createElement("circle", {
  id: "Ellipse_32-11",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1055 1713)"
}), React.createElement("circle", {
  id: "Ellipse_32-12",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1093 1713)"
}), React.createElement("circle", {
  id: "Ellipse_32-13",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(903 1751)"
}), React.createElement("circle", {
  id: "Ellipse_32-14",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(941 1751)"
}), React.createElement("circle", {
  id: "Ellipse_32-15",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(979 1751)"
}), React.createElement("circle", {
  id: "Ellipse_32-16",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1017 1751)"
}), React.createElement("circle", {
  id: "Ellipse_32-17",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1055 1751)"
}), React.createElement("circle", {
  id: "Ellipse_32-18",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1093 1751)"
}), React.createElement("circle", {
  id: "Ellipse_32-19",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(903 1789)"
}), React.createElement("circle", {
  id: "Ellipse_32-20",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(941 1789)"
}), React.createElement("circle", {
  id: "Ellipse_32-21",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(979 1789)"
}), React.createElement("circle", {
  id: "Ellipse_32-22",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1017 1789)"
}), React.createElement("circle", {
  id: "Ellipse_32-23",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1055 1789)"
}), React.createElement("circle", {
  id: "Ellipse_32-24",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1093 1789)"
}), React.createElement("circle", {
  id: "Ellipse_32-25",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(903 1827)"
}), React.createElement("circle", {
  id: "Ellipse_32-26",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(941 1827)"
}), React.createElement("circle", {
  id: "Ellipse_32-27",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(979 1827)"
}), React.createElement("circle", {
  id: "Ellipse_32-28",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1017 1827)"
}), React.createElement("circle", {
  id: "Ellipse_32-29",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1055 1827)"
}), React.createElement("circle", {
  id: "Ellipse_32-30",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1093 1827)"
}), React.createElement("circle", {
  id: "Ellipse_32-31",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(903 1865)"
}), React.createElement("circle", {
  id: "Ellipse_32-32",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(941 1865)"
}), React.createElement("circle", {
  id: "Ellipse_32-33",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(979 1865)"
}), React.createElement("circle", {
  id: "Ellipse_32-34",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1017 1865)"
}), React.createElement("circle", {
  id: "Ellipse_32-35",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1055 1865)"
}), React.createElement("circle", {
  id: "Ellipse_32-36",
  "data-name": "Ellipse 32",
  cx: 1,
  cy: 1,
  r: 1,
  transform: "translate(1093 1865)"
}), React.createElement("g", {
  id: "Group_433",
  "data-name": "Group 433",
  transform: "translate(-682.865 1020.729)"
}, React.createElement("path", {
  id: "Path_978",
  "data-name": "Path 978",
  d: "M1705,765.205c2-1.5,4.479-2.459,6.386-4.366C1719.62,752.6,1724.392,742,1725.107,732H1705Z",
  fill: "#5603ad"
}), React.createElement("path", {
  id: "Path_979",
  "data-name": "Path 979",
  d: "M1668,723h56.907a46.8,46.8,0,0,0-13.211-27.685c-1.861-1.862-3.848-4.315-5.924-5.315H1668Z",
  fill: "#937ef8"
}), React.createElement("path", {
  id: "Path_980",
  "data-name": "Path 980",
  d: "M1660,724V685.545A48.634,48.634,0,0,0,1633.075,724Z",
  fill: "#5603ad"
}), React.createElement("path", {
  id: "Path_981",
  "data-name": "Path 981",
  d: "M1647.687,760.461c3.083,3.083,6.5,4.539,10.125,7.539H1695V731h-60.724A47.475,47.475,0,0,0,1647.687,760.461Z",
  fill: "#ff525f"
}), React.createElement("circle", {
  id: "Ellipse_1213",
  "data-name": "Ellipse 1213",
  cx: 46.178,
  cy: 46.178,
  r: 46.178,
  transform: "translate(1632.865 681.27)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("g", {
  id: "Group_432",
  "data-name": "Group 432"
}, React.createElement("line", {
  id: "Line_76",
  "data-name": "Line 76",
  x2: 11.5,
  y2: 19.919,
  transform: "translate(1701.097 768.138)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("rect", {
  id: "Rectangle_124",
  "data-name": "Rectangle 124",
  width: 16.167,
  height: 40.491,
  transform: "translate(1705.398 792.213) rotate(-30)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 2
}))));

var SvgObservation = function SvgObservation(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgObservation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/observation.9d29feb3.svg";
export { ForwardRef as ReactComponent };